import { AxiosResponseHeaders } from 'axios';
import pickBy from 'lodash/pickBy';

export enum FileType {
  'application/pdf' = 'application/pdf',
  'application/vnd.apple.pkpass' = 'application/vnd.apple.pkpass',
}

export enum Target {
  '_blank' = '_blank',
}

export const downloadFile = (filename: string, data: any, type?: FileType, target?: Target) => {
  const url = window.URL.createObjectURL(new Blob([data], pickBy({ type })));
  const link = window.document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);

  if (target) {
    link.setAttribute('target', target);
  }

  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
};

export const getFilename = (headers: AxiosResponseHeaders) => {
  const contentDisposition = headers['content-disposition'];
  if (!contentDisposition) return;

  const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (filenameStarMatch) {
    try {
      return decodeURIComponent(filenameStarMatch[1]);
    } catch {
      /* noop */
    }
  }

  const filenameMatch = contentDisposition.match(/filename="?([^"';]+)"?/i);
  if (filenameMatch) {
    return filenameMatch[1];
  }

  return;
};
